export const nutsAndHoneyPastry = {
  id: "nutsAndHoneyPastry",
  link: "/#/recipes/recipes/nutsAndHoneyPastry",
  name: "Nuts and Honey Pastry",
  cuisine: "Alethi",
  summary: "Walnuts and lemon honey syrup on crispy corn flour squares",
  inspiration: "Baklava",
  quantity: "About 16",
  time: "1 hour",
  notes:
    "We know that the Alethi eat pastries (Oathbringer ch 69). Unfortunately we don't get any more detail than that. As I was experimenting with pastry doughs, the crispiness of what I ended up with reminded me of phyllo dough. Obviously the pastry is very different, but I tried layering it with similar fillings as what you would use in baklava, and it turned out delicious. If you want to stack them higher than two layers, you definitely can.",
  quotes:
    "I hear they've got storming good pastries at those fancy lighteyes parties. (Oathbringer ch 69)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/nuts-and-honey-pastry-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "lavisPastrySquares",
          display: "1 recipe Lavis Pastry Squares"
        },
        {
          item: "nuts",
          display: "1 1/2 cups walnuts"
        },
        {
          item: "sugar",
          display: "3/4 cup granulated sugar, divided"
        },
        {
          item: "cinnamon",
          display: "1/2 tsp ground cinnamon"
        },
        {
          item: "honey",
          display: "2 tbsp honey"
        },
        {
          item: "cinnamon",
          display: "1 small stick cinnamon"
        },
        {
          item: "water",
          display: "1/4 cup water"
        },
        {
          item: "lemon",
          display: "1 tbsp lemon juice"
        }
      ]
    }
  ],
  steps: [
    "Prepare the Lavis Pastry Squares. Turn the oven heat down to 350 degrees Fahrenheit.",
    "Spread the walnuts on a baking sheet in a single layer, then toast in the oven for about 8 minutes, shaking or stirring the pan every couple minutes. The walnuts should show some oil on the surface and a little bit of color, but should not be overly browned and burned.",
    "Remove the nuts from the oven and chop them finely. Do not process them to a powder. Just chopped finely. Combine with 1/4 cup of the sugar and the 1/2 tsp ground cinnamon. Set aside.",
    "In a saucepan, combine the remaining 1/2 cup sugar, the honey, stick cinnamon, water, and lemon juice. Bring to a boil over medium heat, then reduce heat and simmer for 10 minutes. Remove from heat, and remove and discard the cinnamon sticks.",
    "To assemble, place half of the pastry squares in a rectangle, side by side, all touching each other. Spread half of the reserved nut mixture over the squares. Drizzle with half of the syrup. Place the other half of the pastry squares on top, doing your best to line them up with the squares underneath. Top with the remaining nut mixture, then drizzle with the remaining syrup. Use a spatula to remove individual stacks and serve."
  ]
}
